import request from '../utils/http.js';
// // 上传图片
// export const doctorRegister = (data) => {
// 	return request.post("api/user/doctorRegister", data);
// }
// // 上传图片
// export const scalesub = (data) => {
// 	return request.post("/customer/scale/sub", data);
// }

// 登录
export const getLogin = (data) => {
  return request.post('/login', data);
};

// 发送验证码
export const getSendSms = (data) => {
  return request.post('/sendSms', data);
};

// 修改密码
export const getUpdatePass = (data) => {
  return request.post('/updatePass', data);
};

// 注册
export const getRegister = (data) => {
  return request.post('/register', data);
};

// 关于我们
export const getContactUs = (data) => {
  return request.post('/contactUs', data);
};

// 首页
export const getHome = (data) => {
  return request.post('/getHome', data);
};
// banner
export const getBanner = (data) => {
  return request.post('/getBanner', data);
};
/// 班级
export const getCategoryTwo = (data) => {
  return request.post('/getCategoryTwo', data);
};
/// 课程
export const getCategoryThree = (data) => {
  return request.post('/getCategoryThree', data);
};
// Videos
export const getVideos = (data) => {
  return request.post('/getVideos', data);
};
// Videoinfo
export const getVideoDetail = (data) => {
  return request.post('/getVideoDetail', data);
};
// 修改信息
export const getUserUpdate = (data) => {
  return request.post('/user/update', data);
};

// 观看历史
export const getHistory = (data) => {
  return request.get('/user/history?page=' + data.page, data);
};

// 收藏列表
export const getCollect = (data) => {
  return request.post('/user/collect', data);
};

// 用户隐私协议
export const getXieYi = (data) => {
  return request.get('/getXieYi?key=' + data.key, data);
};
//5秒提交
export const putVideoPlay = (data) => {
  return request.post('/putVideoPlay', data);
};
//收藏
export const putCollect = (data) => {
  return request.post('/putCollect', data);
};
//友情链接
export const getBlogrolls = (data) => {
  return request.post('/getBlogrolls', data);
};
//搜索
export const searchVideos = (data) => {
  return request.post('/searchVideos', data);
};
//我的考试
export const userQuestion = (data) => {
  return request.post('/user/question', data);
};
//考试结果
export const getUserQuestion = (data) => {
  return request.post('/user/getUserQuestion', data);
};
//随堂/结业考试
export const getQuestions = (data) => {
  return request.post('/getQuestions', data);
};
//调研问卷
export const getSurver = (data) => {
  return request.post('/getSurver', data);
};
//随堂/结业提交
export const postQuestions = (data) => {
  return request.post('/postQuestions', data);
};
//调研提交
export const postSurver = (data) => {
  return request.post('/postSurver', data);
};
